import { render, staticRenderFns } from "./StepElement.vue?vue&type=template&id=b0a9e7b8&"
import script from "./StepElement.vue?vue&type=script&lang=js&"
export * from "./StepElement.vue?vue&type=script&lang=js&"
import style0 from "./StepElement.vue?vue&type=style&index=0&id=b0a9e7b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports